interface MetaData {
  title: string;
  description: string;
}

const baseTitle = 'Fight Vision';

export const getRouteMetadata = (path: string): MetaData => {
  switch (path) {
    case '/':
      return {
        title: `${baseTitle} - UFC Fight Predictions & Analysis`,
        description: 'Advanced UFC fight predictions using machine learning and statistical analysis. Get detailed fighter comparisons, win probabilities, and betting insights.',
      };
    case '/prediction-tracker':
      return {
        title: `Prediction Tracker | ${baseTitle}`,
        description: 'Track and analyze our UFC fight prediction accuracy. View historical predictions, success rates, and detailed performance metrics.',
      };
    case '/methodology':
      return {
        title: `Prediction Methodology | ${baseTitle}`,
        description: 'Learn about our advanced machine learning and statistical methods for UFC fight predictions. Understand how we analyze fighter data and generate predictions.',
      };
    default:
      return {
        title: baseTitle,
        description: 'Advanced UFC fight predictions using machine learning and statistical analysis.',
      };
  }
};

export const updateMetaTags = (metadata: MetaData) => {
  document.title = metadata.title;
  
  // Update meta description
  const descriptionTag = document.querySelector('meta[name="description"]');
  if (descriptionTag) {
    descriptionTag.setAttribute('content', metadata.description);
  }

  // Update OpenGraph meta tags
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogTitle) ogTitle.setAttribute('content', metadata.title);
  if (ogDescription) ogDescription.setAttribute('content', metadata.description);

  // Update Twitter meta tags
  const twitterTitle = document.querySelector('meta[property="twitter:title"]');
  const twitterDescription = document.querySelector('meta[property="twitter:description"]');
  if (twitterTitle) twitterTitle.setAttribute('content', metadata.title);
  if (twitterDescription) twitterDescription.setAttribute('content', metadata.description);
}; 